// @core/api/endpoints/payment/get_payment_type.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PaymentTypeDefinitionResponse,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Get payment type
 * Returns a payment type definition by ID or slug.
 */
export async function GetPaymentType(
  type_id: string,
  options?: RequestOptions
): Promise<PaymentTypeDefinitionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/payment-types/:type_id`;
  requestPath = requestPath.replace(':type_id', encodeURIComponent(type_id));
  const requestOptions = options;
  return client.get<PaymentTypeDefinitionResponse>(requestPath, { ...requestOptions });
}
